import * as React from "react";
const SvgNext = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 -960 960 960", width: "1em", fill: "#5f6368", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z" }));
export default SvgNext;
